export const getFlatTreeNode = (id: string, parentId: string, tree: Record<string, string[]>): Record<string, string[] | null> => {
	if (!parentId) return {[id]: null};
	return {[id]: tree[parentId] ? [...tree[parentId], parentId] : [parentId]};
};
